import { DOOR_PRODUCT_ID, getJamsBackendUrl } from '@/utils/account';

export interface IDoorProductSettings {
  Enable?: boolean;
  isActive?: boolean;
  [key: string]: unknown;
}

export function isDoorProductEnabled(settings: IDoorProductSettings | null): boolean {
  if (!settings) return false;
  return settings.Enable === true || settings.isActive === true;
}

export async function getDoorProductSettings(
  accountId: string,
): Promise<IDoorProductSettings | null> {
  const endpoint = getJamsBackendUrl();
  if (!endpoint || !accountId) return null;

  const path = `unauth/account/products/${encodeURIComponent(accountId)}/${DOOR_PRODUCT_ID}`;

  try {
    const response = await fetch(`${endpoint}/${path}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Could not fetch door product settings (${response.status}).`);
    }

    const data = (await response.json()) as IDoorProductSettings;
    return data ?? null;
  } catch (err) {
    console.error('[jzl-door] Failed to fetch door product settings', err);
    return null;
  }
}
